import { render, staticRenderFns } from "./variables-list.vue?vue&type=template&id=abc1f1b8&scoped=true&"
import script from "./variables-list.vue?vue&type=script&lang=js&"
export * from "./variables-list.vue?vue&type=script&lang=js&"
import style0 from "./variables-list.vue?vue&type=style&index=0&id=abc1f1b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc1f1b8",
  null
  
)

export default component.exports